
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAccountPassword } from '@/modules/account/system/model/password';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';

export default defineComponent({
    name: ROUTE_NAME_ACCOUNT.SYSTEM.PASSWORD,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, actions } = useAccountPassword();

        return { v$, model, actions };
    }
});
